<header>
  <div class="fixed-top"
       [ngClass]="{ 'mat-elevation-z10 bg-white': isShowBackground}"
       [@showBackground]="isShowBackground? 'show': 'hide'">
    <div class="container px-md-0">
      <ng-container *ngTemplateOutlet="topBarTemplate"></ng-container>
    </div>
    <nav *ngIf="isActiveMenu"
         class="position-absolute pb-2"
         [@toggleMenu]="isActiveMenu">
      <div class="container px-md-0">
        <ng-container *ngTemplateOutlet="topBarTemplate"></ng-container>
      </div>
      <mat-divider></mat-divider>
      <div class="container px-md-0" [ngClass]="{'full-height': isMobile && isActiveMenu}">
        <div class="row mx-0 py-2 menu-columns">
          <!-- Left Column: Menu -->
          <div class="col-md-6 col-12 menu-column">
            <ul class="nav">
              <li class="nav-item">
                <a class="nav-link title">{{'action_buttons.menu' | transloco}}</a>
              </li>
            </ul>
            <ul class="nav">
              <li class="nav-item">
                <a class="nav-link" [routerLink]="['/alle-kurs']">{{'layout.nav_links.all_courses' | transloco}}</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" [routerLink]="['/kursoversikt-for-tilbydere']">{{'layout.nav_links.become_an_instructor' | transloco}}</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" [routerLink]="['/om-sjoliv']">{{'layout.nav_links.about_sjoliv' | transloco}}</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="https://rs.no/kundeservice/" target="_blank">{{'layout.nav_links.contact' | transloco}}</a>
              </li>
            </ul>
          </div>
          <!-- Right Column: User Menu (only if user is logged in) -->
          <ng-container *ngIf="user">
            <div class="col-md-6 col-12 menu-column">
              <ul class="nav">
                <li class="nav-item">
                  <a class="nav-link title">{{user.name}}</a>
                </li>
              </ul>
              <ul class="nav">
                <ng-container [ngTemplateOutlet]="authenticatedLinks"></ng-container>
              </ul>
            </div>
          </ng-container>
        </div>
      </div>
    </nav>
  </div>
</header>

<ng-template #topBarTemplate>
  <div class="row navbar bg-transparent align-items-center menu-bar">
    <div class="col">
      <a class="d-block" [routerLink]="'/'">
        <img src="assets/icons/logo_2.png" class="rs-logo"/>
      </a>
    </div>
    <div class="col">
      <div class="d-flex align-items-center justify-content-end">
        <ng-container
          [ngTemplateOutlet]="(user && !isMobile && isAuthenticated) ? userProfileTemplate : signInPromptTemplate">
        </ng-container>
        <button type="button"
                [class]="'btn btn-menu'+' '+ toolbarTextColor"
                [ngClass]="{'active': isActiveMenu}"
                aria-label="Toggle navigation"
                (click)="toggleMenu()">
          <ng-container *ngIf="!isActiveMenu">
            <mat-icon>menu</mat-icon>
            {{'action_buttons.menu' | transloco}}</ng-container>
          <ng-container *ngIf="isActiveMenu">
            <mat-icon>close</mat-icon>
            {{'action_buttons.close' | transloco}}</ng-container>
        </button>
      </div>
    </div>
  </div>
</ng-template>


<ng-template #signInPromptTemplate>
  <ng-container *ngIf="(!isAuthenticated && !user)">
    <button
      *ngIf="!isMobile"
      type="button"
      class="btn btn-menu d-flex align-items-center"
      [ngClass]="toolbarTextColor"
      [routerLink]="['/auth/login']">
      <mat-icon>person_outline</mat-icon>
      {{'layout.nav_links.log_in' | transloco}}
    </button>
  </ng-container>
</ng-template>

<ng-template #userProfileTemplate>
  <button [matMenuTriggerFor]="userMenu" [disabled]="isActiveMenu" type="button"
          class="btn btn-menu d-flex align-items-center text-capitalize"
          [ngClass]="toolbarTextColor">
    <img class="user-profile-pic mr-2" [src]="user?.picture || 'assets/images/user.png' ">
    {{user.name}}
    <mat-icon [class]="toolbarTextColor">arrow_drop_down</mat-icon>
  </button>
</ng-template>

<ng-template #authenticatedLinks>
  <li class="nav-item">
    <a class="nav-link" [routerLink]="['/bruker/min-side']">{{'layout.nav_links.profile' | transloco}}</a>
  </li>
  <li class="nav-item">
    <a class="nav-link"
       [routerLink]="['/booking/mine-bookinger/kurs/aktiv']">{{'layout.nav_links.my_courses' | transloco}}</a>
  </li>
  <li class="nav-item">
    <a class="nav-link" (click)="logout()">{{'layout.nav_links.log_out' | transloco}}</a>
  </li>
</ng-template>
<mat-menu #userMenu="matMenu" [class]="'bg-white'">
  <ul class="nav d-block">
    <ng-container [ngTemplateOutlet]="authenticatedLinks"></ng-container>
  </ul>
</mat-menu>
